import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import { Container } from 'components/basics';
import { breakpoint } from 'utils/mediaQueries';
import DescriptionBlock from 'components/pages/Qemotion/DescriptionBlock/DescriptionBlock';

const StyledGrid = styled(Grid)`
  margin-top: -8rem;
  padding-bottom: 6rem;
  ${breakpoint.down('md')`
  margin-top: 0; padding-bottom: 0; justify-content: center`}
`;
const ContentBlock = styled(Grid)`
  max-width: 1200px;
  width: 100%;
  ${breakpoint.down('md')`
  flex-direction: row-reverse; padding-top: 4rem`}
`;
const SocialGrid = styled(Grid)`
  text-align: left;
  ${breakpoint.down('md')`
  padding-top:0 !important; align-items: center;`}
`;
const DescriptionGrid = styled(Grid)`
  flex: 0 0 auto;
`;
const DescriptionBlocks = ({ data }) => {
  return (
    <Container>
      <ContentBlock
        container
        spacing={24}
        justify="center"
        alignItems="flex-start"
        direction="column"
      >
        {data.markdownContent.map((block, index) => {
          if (block.frontmatter.component === 'story') {
            return (
              <Grid
                container
                direction={'column'}
                item
                xs={12}
                sm={12}
                md={7}
                lg={7}
                key={`DescriptionBlock${index}`}
                justify={'center'}
                alignItems={'center'}
              >
                <DescriptionGrid item xs={11} sm={8} md={12} lg={12}>
                  <DescriptionBlock data={block} />
                </DescriptionGrid>
              </Grid>
            );
          } else {
            return (
              <StyledGrid
                container
                justify={'flex-end'}
                key={`DescriptionBlock${index}`}
              >
                <SocialGrid
                  container
                  direction={'column'}
                  item
                  xs={11}
                  sm={12}
                  md={5}
                  lg={5}
                  justify={'center'}
                >
                  <DescriptionGrid item xs={12} sm={8} md={8} lg={8}>
                    <DescriptionBlock data={block} />
                  </DescriptionGrid>
                </SocialGrid>
              </StyledGrid>
            );
          }
        })}
      </ContentBlock>
    </Container>
  );
};

export default DescriptionBlocks;
